import Employee from "@/employee/Employee"
import ValueMod from "@/effects/ValueMod"
import util from "@/util"

export abstract class Personality {
  abstract readonly id: string
  abstract readonly affix: string

  abstract description(): string

  onUpdate(dt: number, employee: Employee): void {}

  onSex(employee: Employee): void {}

  onCuddle(employee: Employee): void {}

  onGift(employee: Employee): void {}

  get name(): string {
    return util.capitalize(this.id)
  }

  /** Returns values this personality wants to multiply default constants with. */
  get constantMods(): { [key: string]: [ValueMod] } {
    return {}
  }

  get conflictingPersonalities(): Personality[] {
    return []
  }

  /**
   * Rescales a fraction so that when it is a threshold value, the rescaled is 0,
   * and when the fraction is 1, the rescaled is also 1.
   * @param fraction the original value to rescale
   * @param threshold when fraction is this value, the new returned fraction will be 1
   */
  rescaleFraction(fraction: number, threshold: number): number {
    return (fraction - threshold) / (1 - threshold)
  }
}

export class EmptyPersonality extends Personality {
  id: string = 'empty'
  affix: string = 'prefix'

  description(): string {
    return 'No personality.'
  }
}
